import React, {useEffect} from 'react';
import {useGetDashboardAnalyticsQuery} from '../api/dashboard';
import DashboardCardWrapper from '../components/common/DashboardCardWrapper';
import CandidateStatistics from '../components/dashboard/CandidateStatistics';
import JobStatistics from '../components/dashboard/JobStatistics';
import UserStatistics from '../components/dashboard/UserStatistics';
import LatestJobTable from '../components/LatestJobTable';
import {pageRoutes} from '../routes';
import {useNavigate} from 'react-router-dom';
const DashboardV2 = () => {
  const {data, isLoading} = useGetDashboardAnalyticsQuery();
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/assessments');
  }, []);
  if (isLoading) {
    return 'loading...';
  }

  const {dashboardDataObj, lastJobs} = data.data;

  return (
    <div className="flex flex-col gap-5 px-8 py-6">
      <CandidateStatistics statistics={dashboardDataObj} />

      <div className="grid grid-cols-2 gap-5">
        <JobStatistics statistics={dashboardDataObj} />
        <UserStatistics statistics={dashboardDataObj.userCount} />
      </div>

      <div className="flex flex-col gap-5 bg-white">
        <DashboardCardWrapper
          title="Recently posted jobs"
          redirectURL={pageRoutes.manageJob}
        />
        <div className="px-8">
          <LatestJobTable tableData={lastJobs} />
        </div>
      </div>
    </div>
  );
};

export default DashboardV2;
